import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Embed.svg'

export const IconEmbed = IconSVG as IconComponent
